import type { WordPackDefinition } from "./types";

// Kahoot! themed words for team building
export const KAHOOT_WORDS = [
  // Game Mechanics
  "HOST", "PLAYER", "LOBBY", "PODIUM", "PIN", "JOIN", "POINTS", "STREAK", "COMBO", "TIMER",
  "SCORE", "WINNER", "RANKING", "LEADERBOARD", "BONUS", "BOOST", "COUNTDOWN", "ANSWER", "QUESTION", "CORRECT",
  "MUSIC", "CELEBRATE", "COMPETE", "RACE", "PLAY",
  // Content/Product
  "QUIZ", "POLL", "SURVEY", "SLIDE", "PUZZLE", "CHALLENGE", "TEMPLATE", "COLLECTION", "LIBRARY", "DISCOVER",
  "CREATE", "SHARE", "DRAFT", "PUBLISH", "PREVIEW", "DUPLICATE", "FOLDER", "SEARCH", "FILTER", "TAG",
  // Education
  "STUDY", "LEARN", "ASSIGN", "REPORT", "STUDENT", "TEACHER", "CLASS", "COURSE", "LESSON", "PRACTICE",
  "REVIEW", "FLASHCARD", "MEMORY", "BRAIN", "THINK", "FOCUS", "TEST", "EXAM", "GRADE", "PROGRESS",
  // General/Fun
  "TEAM", "GROUP", "FAST", "CHOICE", "SELECT", "OPTION", "ROUND", "LEVEL", "STAGE", "CHAMPION",
  "TROPHY", "MEDAL", "CONFETTI", "PARTY", "ENERGY", "SPARK", "FLASH", "INSTANT", "LIGHTNING", "ROCKET",
];

export const KAHOOT_SEMANTIC_FAMILIES: string[][] = [
  ["HOST", "PLAYER", "LOBBY", "PIN", "JOIN"],
  ["POINTS", "SCORE", "STREAK", "COMBO", "BONUS", "BOOST", "LEADERBOARD", "RANKING", "WINNER", "PODIUM"],
  ["QUESTION", "ANSWER", "CORRECT", "QUIZ", "POLL", "SURVEY", "CHALLENGE"],
  ["STUDENT", "TEACHER", "CLASS", "COURSE", "LESSON", "STUDY", "LEARN", "TEST", "EXAM", "GRADE", "FLASHCARD"],
  ["CREATE", "SHARE", "DRAFT", "PUBLISH", "PREVIEW", "DUPLICATE", "FOLDER", "SEARCH", "FILTER", "TAG"],
  ["ROUND", "LEVEL", "STAGE", "CHAMPION", "TROPHY", "MEDAL", "TEAM", "GROUP"],
  ["MUSIC", "PARTY", "CONFETTI", "CELEBRATE", "ENERGY", "SPARK", "LIGHTNING", "ROCKET"],
];

export const KAHOOT_PACK: WordPackDefinition = {
  key: "kahoot",
  words: KAHOOT_WORDS,
  semanticFamilies: KAHOOT_SEMANTIC_FAMILIES,
};
